import React from 'react';
import styled from 'styled-components';

interface IRefundIconProps {
  user?: 'landlord' | 'tenant';
}

const StyledSvg = styled.svg<IRefundIconProps>`
  display: block;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

const Refund = ({ user = 'landlord' }: IRefundIconProps): JSX.Element => (
  <StyledSvg
    user={user}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
  >
    <path
      d="M26.246 5.687a.781.781 0 100-1.563.781.781 0 000 1.563zM39.592 25.252a3.202 3.202 0 00-4.414-1.212l-8.191 4.575a3.13 3.13 0 00-3.083-2.617H21.08c-.658 0-1.305-.333-1.82-.936-1.531-1.794-3.837-2.552-6.17-2.027a6.223 6.223 0 00-3.223 1.907 3.19 3.19 0 01-1.587.957v-.682a.781.781 0 00-.78-.781H.78a.781.781 0 00-.781.78v12.5c0 .43.35.78.781.78H7.5c.432 0 .781-.35.781-.78v-.583s16.383 1.364 16.405 1.364a.782.782 0 00.431-.13l5.907-3.905a.781.781 0 00-.862-1.303l-5.681 3.756-16.2-1.35v-8.07a4.752 4.752 0 002.75-1.51 4.65 4.65 0 012.405-1.426c1.755-.395 3.488.172 4.636 1.517.818.957 1.886 1.484 3.01 1.484h2.823c.861 0 1.562.701 1.562 1.563a1.56 1.56 0 01-1.562 1.562h-7.03a.781.781 0 000 1.562h7.03a3.115 3.115 0 002.76-1.662l9.297-5.193a1.64 1.64 0 012.266.618 1.634 1.634 0 01-.503 2.148l-2.352 1.555a.782.782 0 00.862 1.303l2.367-1.565a3.189 3.189 0 00.991-4.2zM6.718 36.934H1.562V25.998h5.156v10.936z"
      fill="#000"
    />
    <path
      d="M26.249 1C19.788 1 14.53 6.256 14.53 12.718c0 6.46 5.257 11.717 11.718 11.717s11.718-5.256 11.718-11.717C37.967 6.256 32.71 1 26.249 1zm0 21.873c-5.6 0-10.155-4.556-10.155-10.155 0-5.6 4.555-10.156 10.155-10.156s10.155 4.556 10.155 10.156c0 5.6-4.556 10.155-10.155 10.155z"
      fill="#000"
    />
    <path
      d="M29.615 4.812A.781.781 0 1029 6.25a7.031 7.031 0 014.276 6.468 7.039 7.039 0 01-7.03 7.03 7.038 7.038 0 01-7.031-7.03A7.031 7.031 0 0123.49 6.25a.781.781 0 10-.614-1.437 8.592 8.592 0 00-5.224 7.905c0 4.739 3.855 8.593 8.593 8.593 4.738 0 8.593-3.854 8.593-8.593a8.592 8.592 0 00-5.223-7.905z"
      fill="#000"
    />
    <path
      d="M26.327 13.42a.782.782 0 010 1.563c-.334 0-.694-.21-1.014-.591a.781.781 0 00-1.196 1.005c.417.497.908.843 1.429 1.017v.912a.781.781 0 001.562 0v-.915a2.348 2.348 0 001.563-2.21 2.346 2.346 0 00-2.344-2.343.782.782 0 010-1.562c.277 0 .569.14.845.408a.782.782 0 001.086-1.123 3.017 3.017 0 00-1.15-.719v-.91a.781.781 0 10-1.562 0v.916a2.347 2.347 0 00-1.563 2.209 2.346 2.346 0 002.344 2.343zM33.98 32.09a.782.782 0 10-1.563.002.782.782 0 001.563-.001z"
      fill="#000"
    />
  </StyledSvg>
);

export default Refund;
